import React from 'react';
import { FilterTab } from '../types';

interface ConversationFiltersProps {
  activeFilter: FilterTab;
  onFilterChange: (filter: FilterTab) => void;
  userRole: 'candidate' | 'recruiter';
}

/**
 * Filter tabs for conversations
 * Improved: Pill-style segmented control, better active states
 */
const ConversationFilters: React.FC<ConversationFiltersProps> = ({
  activeFilter,
  onFilterChange,
  userRole
}) => {
  const filters: { id: FilterTab; label: string }[] = [
    { id: 'all', label: 'All' },
    ...(userRole === 'candidate' ? [{ id: 'david' as FilterTab, label: 'David' }] : []),
    { id: 'active', label: 'Active' },
    { id: 'declined', label: 'Declined' }
  ];

  return (
    <div className="w-full">
      <div className="flex items-center gap-1 p-1 w-full bg-[#F1F3F4] rounded-xl">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`
              flex-1 flex items-center justify-center px-3 py-2 rounded-lg
              font-manrope text-sm font-medium
              transition-all duration-200 ease-out
              ${activeFilter === filter.id
                ? 'bg-white text-[#015FA6] shadow-sm'
                : 'text-[#6B7280] hover:text-[#374151] hover:bg-white/50'}
            `}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConversationFilters;
